<template>
    <div class="loginContainer">
        <img src="../assets/imgs/login/logo.png" alt="" class="logo">
        <div v-show="allowUserNameLogin">
            <div class="forms">
                <input type="text" placeholder="请输入账号" v-model="card" @input="inpChange">
                <input type="password" placeholder="请输入密码" v-model="psw" @input="inpChange">
                <p v-show="isError">{{message}}</p>
                <div @click="login">立即登录</div>
            </div>
            <div class="otherLogin" v-if="allowWeChatAuth">
                <div class="head">
                    <div></div>
                    <p>其他账号登录</p>
                    <div></div>
                </div>
                <img src="../assets/imgs/login/wechat.png" alt="" @click="goWechat">
            </div>
        </div>
        <div v-show="!allowUserNameLogin && allowWeChatAuth">
            <div @click="goWechat">
                <div>微信登录</div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            card: "",
            psw: "",
            isError: false,
            message: "",
            allowWeChatAuth: false,
            allowUserNameLogin: true,
        }
    },
    computed: {

    },
    created() {
        var that = this;
        if( localStorage.getItem("allowWeChatAuth") == 'N' ) {
            that.allowWeChatAuth = false;
        }else{
            that.allowWeChatAuth = true;
        }
        if( localStorage.getItem("allowUserNameLogin") == 'N' ) {
            that.allowUserNameLogin = false;
        }else{
            that.allowUserNameLogin = true;
        }
        
        
    },
    methods: {
        login() {
            var that = this;
            if( that.commin.fn.trim( that.card ).length < 1 ) {
                that.message = "账号不能为空";
                that.isError = true;
                return false;
            }
            if( that.psw.length < 1 ) {
                that.message = "密码不能为空";
                that.isError = true;
                return false;
            }
            var data = {
                loginName: that.$rsa.encrypt(localStorage.getItem("puk"), that.commin.fn.trim( that.card )).replace(/\//g, "*"),
                password:  that.$rsa.encrypt(localStorage.getItem("puk"), that.psw).replace(/\//g, "*"),
                ticket: localStorage.getItem("ticket")
            }
            that.allApi.login(data).then((resource)=>{
                // console.log(that.$rsa.checkSign(localStorage.getItem("puk"), resource.data.data.message, resource.data.data.sign))
                // if( resource.data.data.flag && that.$rsa.checkSign(localStorage.getItem("puk"), resource.data.data.message, resource.data.data.sign) ) {
                if( resource.data.data.flag ) {
                    // console.log(JSON.parse(resource.data.data.message))
                    // 昵称
                    localStorage.setItem("nickName", JSON.parse(resource.data.data.message).nickName);
                    // 用户名
                    localStorage.setItem("userName", JSON.parse(resource.data.data.message).userName);
                    // 用户头像
                    localStorage.setItem("headPortrait", JSON.parse(resource.data.data.message).headPortrait);
                    // 是否登录
                    localStorage.setItem("status", JSON.parse(resource.data.data.message).status);
                    localStorage.removeItem("showRowNum");
                    
                    // 某些机构第一次登陆提示修改密码
                    // localStorage.setItem("initialPasd", JSON.parse(resource.data.data.message).initialPasd);
                    // if( JSON.parse(resource.data.data.message).initialPasd == 1 ) {
                    //     let data = {
                    //         msg: "请修改初始密码"
                    //     }
                    //     that.$emit("dialogChange", data);
                    // }

                    // 用户账号到期时间
                    if( JSON.parse(resource.data.data.message).expireDate ) {
                        localStorage.setItem("expireDate", JSON.parse(resource.data.data.message).expireDate);
                    }else{
                        localStorage.setItem("expireDate", -1);
                    }
                    // 用户账号类型 0是会员  1是普通
                    localStorage.setItem("userType", JSON.parse(resource.data.data.message).userType);

                    that.$router.push("/self");
                }else{
                    // that.message = resource.data.data.message;
                    that.message = '登录失败，请稍后重试~';
                    that.isError = true;
                }
                
                // console.log(resource.data);
                
            })
        },
        goWechat() {
            var that = this;
            // location.href = "http://cms.yuntuys.com/api/auth/authorize/"+ localStorage.getItem("ticket") +"/zh_CN/1";
            location.href = "http://open-service.yuntuys.com/api/auth/authorize/"+ localStorage.getItem("ticket") +"/zh_CN/1";
            // location.href = "http://syg-tx.yuntuys.com/api/auth/authorize/"+ localStorage.getItem("ticket") +"/zh_CN/1";
            // location.href = "http://bang.yuntuys.com/api/auth/authorize/"+ localStorage.getItem("ticket") +"/zh_CN/1";
        },
        inpChange() {
            var that = this;
            that.isError = false;
        },
    },
    watch: {

    }
}
</script>
<style lang="scss" scoped>
@function rem($args) {
  $uiWidth: 75px;
  @return $args/$uiWidth * 1rem;
}
.loginContainer{
    position: absolute;
    left: 0;
    width: 100%;
    bottom: 0;
    top: 0;
    background: #fff;
    overflow: hidden;
    
    .logo{
        margin: rem(60px) auto rem(90px);
        display: block;
        width: rem(320px);
        height: rem(100px);
    }
    >div:first-of-type{
        .forms{
            padding: 0 rem(64px);
            margin-bottom: rem(65px);
            position: relative;
            input{
                display: block;
                width: 100%;
                height: rem(100px);
                font-size: rem(28px);
                border: 0;
                border-bottom: 1px solid #e5e5e5;
                outline: none;
                color: #999;
                line-height: rem(100px);
                &:focus{
                    color: #999;
                }
            }
            >p{
                position: absolute;
                left: rem(64px);
                top: rem(200px);
                color: #e75652;
                margin-top: rem(30px);
            }
            >div{
                margin-top: rem(120px);
                color: #fff;
                background: #007AFF;
                border-radius: rem(90px);
                line-height: rem(90px);
                text-align: center;
                font-size: rem(36px);
            }
        }
        .otherLogin{
            padding: 0 rem(80px);
            .head{
                text-align: center;
                color: #65ADEF;
                line-height: rem(33px);
                font-size: rem(24px);
                display: flex;
                align-items: center;
                margin-bottom: rem(35px);
                >p{
                    margin: 0 rem(30px);
                }
                >div{
                    width: 0%;
                    flex: 1;
                    height: 1px;
                    background: #65ADEF;
                }
            }
            img{
                display: block;
                width: rem(100px);
                height: rem(100px);
                margin: 0 auto;
            }
        }
    }
    >div:last-of-type{
        padding: rem(64px);
        >div{
            height: rem(90px);
            line-height: rem(90px);
            color: #fff;
            background: #007AFF;
            border-radius: rem(90px);
            font-size: rem(36px);
            display: flex;
            justify-content: center;
            >div{
                margin: 0 auto;
                background: url('../assets/imgs/login/wechat1.png') 0 center / rem(64px) no-repeat;
                padding-left: rem(84px);
            }
        }
    }
}
</style>
